import axios from './axios.service'
import authHeader from './auth-header'

const token = authHeader()

class JobService {
  async getJobFormOption () {
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}/create/job`,
        headers: { Authorization: token.Authorization }
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async getAll (queryData) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/job`,
        { headers: token, params: { ...queryData } }
      )
      return response.data
    } catch (error) {
      return error
    }
  }

  async getJobInformation (id) {
    try {
      const response = await axios({
        method: 'get',
        url: `${process.env.VUE_APP_API_URL}/job/${id}`,
        headers: { Authorization: token.Authorization }
      })
      return response.data
    } catch (error) {
      console.log(error)
    }
  }

  async updateStatus (rowClicked, status) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/job/update/status/${rowClicked.id}`,
        headers: { Authorization: token.Authorization },
        data: {
          status
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async deleteJob (rowClicked) {
    try {
      const response = await axios.delete(
        `${process.env.VUE_APP_API_URL}/job/${rowClicked.id}`,
        { headers: token }
      )
      return response
    } catch (error) {
      return error
    }
  }

  async storeJob (data) {
    try {
      const response = await axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/job`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error
    }
  }

  async updateJob (id, data) {
    try {
      const response = await axios({
        method: 'put',
        url: `${process.env.VUE_APP_API_URL}/job/${id}`,
        headers: { Authorization: token.Authorization },
        data: {
          ...data
        }
      })
      return response
    } catch (error) {
      return error.response
    }
  }

  async checkJobUrl (slug, id) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_URL}/checkurl/job`,
        { headers: token, params: { url: slug, id } }
      )
      return response
    } catch (error) {
      return error
    }
  }
}

export default new JobService()
